export default __webpack_public_path__ + "static/media/151-switch-off.0a907475.png";